
import { Vue, Component, Mixins } from 'vue-property-decorator';
import BScroll from 'better-scroll';
import {
  Popover,
  FormItem,
  Form,
  Input,
  Button,
} from 'element-ui';
import { ITButton } from '@/components/Button/index.d';
import api from '@/api/asset';
import { IAssetSearchForm } from '@/types/asset.d';
import tButton from '@/components/Button/tButton.vue';
import { tSearch } from '@/components/Search/index';
import noData from '@/components/noData/index.vue';
import PageMinix from '@/views/Home/mixins/pageMixin';
import BSMinix from '@/views/Home/mixins/bsMixin';
import tTag from '../manage/components/tag.vue';
import tBox from '../manage/components/box.vue';
import SearchForm from './components/searchForm.vue';

enum AssetType {
  Sound = 'sounds',
  Sprite = 'sprites',
  Stage = 'stages',
}

@Component({
  components: {
    Popover,
    tButton,
    tTag,
    tBox,
    tSearch,
    SearchForm,
    noData,
    Form,
    FormItem,
    Input,
    Button,
  },
})
export default class AssetPublic extends Mixins(PageMinix, BSMinix) {
  private removeBtn: ITButton = {
    title: '删除',
    type: 'primary',
    icon: 'trash-o',
    disabled: true,
    callback: () => this.handleRemoveBtn(),
  };

  /* eslint-disable global-require */
  private tagConf: Array<{ name: string, imgUrl: any, value: AssetType }> = [
    {
      name: '角色',
      value: AssetType.Sprite,
      imgUrl: require('../manage/icons/sprite.svg'),
    },
    {
      name: '声音',
      value: AssetType.Sound,
      imgUrl: require('../manage/icons/sound.svg'),
    },
    {
      name: '背景',
      value: AssetType.Stage,
      imgUrl: require('../manage/icons/background.svg'),
    },
  ];

  private loading: {[key: string]: boolean} = {
    page: false,
    modal: false,
    submit: false,
    sortBtn: false,
  };

  private curPageTag: AssetType = AssetType.Sprite;

  private checkPageData: {[key: string]: Array<string>} = {
    sprites: [],
    sounds: [],
    stages: [],
  };

  private searchTitle: string = '';

  private datas: any = [];

  private activateFlag: boolean = false; // 默认不是高级搜索

  private bs?: BScroll;

  private flag: boolean = true;

  private rules: {[key: string]: any} = {
    sort: [
      { required: true, message: '请填写序号', trigger: 'change' },
      { type: 'number', message: '请输入整数', trigger: 'change' },
      { pattern: /^\d{1,3}$/, message: '序号应为0-999', trigger: 'change' },
    ],
  };

  private form: { sort: number | string } = {
    sort: '',
  };

  public $refs!: {
    page: HTMLElement,
    searchForm: SearchForm;
    content: HTMLElement,
    form: Form[],
  };

  mounted() {
    this.page.pageSize = 50;
    this.getData(true);
    this.bs = this.initBS(this.$refs.page, { scrollbar: { fade: false } });
    this.bs.on('scrollEnd', (cood: any) => {
      if (cood.y === 0) return;
      const contentHeight: number = this.$refs.page.clientHeight;
      const wrapperHeight: number = Math.abs(this.$refs.content.getBoundingClientRect().height);
      if (this.datas.length === (this.page.total || 0)) return;
      if (this.flag) return;
      if (contentHeight + Math.abs(cood.y) > wrapperHeight - 180) {
        this.flag = true;
        this.page.pageNo += 1;
        this.getData(false);
      }
    });
  }

  // 打开排序
  editSortOpen(index: number) {
    this.form.sort = '';
    this.$refs.form[index].resetFields();
  }

  /**
   * @author Terry
   * @description 得到角色下的造型
   * @params { string } md5
   */
  compAsset(md5: any) {
    if (this.curPageTag === AssetType.Sprite) {
      const md5s: any = md5 && JSON.parse(md5);
      return md5s && md5s.map((em: any) => `${process.env.VUE_APP_ASSET_HOST}/${em}`);
    }
    if (this.curPageTag === AssetType.Sound) return `${process.env.VUE_APP_ASSET_HOST}/${md5}`;
    return null;
  }

  /**
   * @author Terry
   * @description 得到缩略图
   * @params { string } md5
   */
  compCover(md5: string) {
    if (this.curPageTag === AssetType.Sound) return require('../manage/icons/sound-bg.png');
    return md5;
  }

  /**
   * @author Terry
   * @description 处理标签点击
   * @params tag
   */
  handleTagClick(tag: { name: string, imgUrl: any, value: AssetType }) {
    if (this.curPageTag !== tag.value) {
      this.curPageTag = tag.value;
      this.getData();
    }
  }

  /**
   * @author Terry
   * @description 获取数据
   * @param flag 是否重新赋值数据  true 为重新赋值数据  false 追加数据
  */
  getData(flag: boolean = true) {
    this.loading.page = true;
    if (flag) {
      this.page.pageNo = 1;
      this.page.total = 0;
      this.datas = [];
    }
    let params: IAssetSearchForm = {
      pageSize: this.page.pageSize,
      pageNo: this.page.pageNo,
      type: this.handleAssetTypeConvert(this.curPageTag),
    };
    if (this.activateFlag) {
      const form: any = this.$refs.searchForm.getFormData();
      params = { ...params, ...form };
    } else params = { ...params, title: this.searchTitle };
    api.getPublicAsset(params).then((res: any) => {
      this.page.total = res.totalElements;
      const result: any = res.content.map((em: any) => ({
        title: em.title,
        data: JSON.parse(em.data),
        thumbs: em.thumbs ? em.thumbs : `${em.thumbMd5}.${em.thumbExt}`,
        id: em.id,
        sort: em.sequence,
        show: false,
        imgUrl: `${process.env.VUE_APP_ASSET_HOST}/${em.thumbMd5}.${em.thumbExt}`,
      }));
      this.datas.push(...result);
      this.loading.page = false;
      this.flag = false;
    /* eslint-disable no-return-assign */
    }).catch(() => {
      this.loading.page = false;
      this.flag = false;
    });
  }

  // 处理删除按钮的逻辑
  handleRemoveBtn() {
    const ids: string[] = [];
    Object.values(this.checkPageData).forEach((em: any) => ids.push(...em));
    this.confirm(`此操作将删除 ${ids.length} 个公共素材, 是否继续?`, {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.deletePublicAsset(ids.join(',')).then((res: any) => {
        this.getData();
        close();
        this.checkPageData.sprites = [];
        this.checkPageData.sounds = [];
        this.checkPageData.stages = [];
        this.removeBtn.disabled = true;
        this.$log({
          title: '素材管理 - 公共素材 - 删除 - 确定',
          component: 'asset/public/index',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '素材管理 - 公共素材 - 删除 - 取消',
      component: 'asset/public/index',
    }));
  }

  /**
   * @author yubiao
   * @desc 高级搜索普通搜索切换事件
   * @param { boolean } activate 是否切换
   */
  handleActivateChange(activate: boolean) {
    this.activateFlag = activate;
    if (activate) {
      this.$refs.searchForm.setTitle(this.searchTitle);
      this.searchTitle = '';
    } else this.searchTitle = this.$refs.searchForm.getFormData().title;
  }

  /**
   * @author terry
   * @description 搜素词改变事件
   */
  handleSearchChange(v: string) {
    this.searchTitle = v;
    this.getData(true);
  }

  /**
   * @author terry
   * @desc 高级搜索提交事件
   */
  handleAdvancedSearch() {
    this.getData(true);
  }

  /**
   * @author terry
   * @desc 高级搜索清空按钮事件
   */
  handleAdvanceClear() {
    this.$refs.searchForm.handleClear();
    this.getData(true);
  }

  /**
   * @author Terry
   * @description 判断是否包含脚本
   */
  /* eslint-disable class-methods-use-this */
  handleHasScript(item: any): boolean {
    return item.source && (!!(Object.keys(item.source.blocks).length)
    || !!(Object.keys(item.source.broadcasts).length)
    || !!(Object.keys(item.source.comments).length)
    || !!(Object.keys(item.source.lists).length));
  }

  /**
   * @author Terry
   * @description 处理页面的收藏
   * @params MD5 文件名
   */
  handlePageCheck(md5: string) {
    const index: number = this.checkPageData[this.curPageTag].indexOf(md5);
    if (index >= 0) this.checkPageData[this.curPageTag].splice(index, 1);
    else this.checkPageData[this.curPageTag].push(md5);
    this.removeBtn.disabled = !(this.checkPageData.sprites.length > 0
    || this.checkPageData.sounds.length > 0
    || this.checkPageData.stages.length > 0);
  }

  /**
   * @author Terry
   * @description 讲前台资源类型转化为后台资源类型
   * @param { AssetType } item
  */
  handleAssetTypeConvert(item: AssetType) {
    switch (item) {
      case AssetType.Sound: return 'sound';
      case AssetType.Sprite: return 'sprite';
      case AssetType.Stage: return 'background';
      default: return undefined;
    }
  }

  // 处理排序表单提交
  handleFormSubmit(id: string, index: number, item: any) {
    this.loading.sortBtn = true;
    (this.$refs.form[index] as Form).validate((valid: boolean) => {
      if (valid) {
        api.editPublicAssetSort({ id, sequence: this.form.sort }).then(() => {
          this.$refs.form[index].resetFields();
          /* eslint-disable no-param-reassign */
          item.show = false;
          this.getData();
        }).finally(() => (this.loading.sortBtn = false));
      } else this.loading.sortBtn = false;
    });
  }
}
